import { render, staticRenderFns } from "./case-general-tab.vue?vue&type=template&id=074528b2&"
import script from "./case-general-tab.vue?vue&type=script&lang=js&"
export * from "./case-general-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports